
const newModel = () => {
    return {
        huanLuyenVienId: null,
        ten: null,
        diaChi: null,
        sdt: null,
        ghiChu: null,
        stt: null,
        enabled: null,
        enabledDisplay: null,
        iocId: null,
        iocEnabled: null,
        iocEnabledDisplay: null,
        iocDateUpdated: null,

        dateCreated: null,
        userCreated: null,
        dateModified: null,
        userModified: null,
        isDeleted: null,
        userDeleted: null,
        dateDeleted: null,
        tenUserCreated: null,
        tenUserModified: null,
        tenUserDeleted: null,
        thethaoBomonInfo: [],
    }
}

const newFEModel = () => {
    return {
        huanLuyenVienId: null,
        ten: null,
        diaChi: null,
        sdt: null,
        ghiChu: null,
        stt: "0",
        enabled: true,
        thethaoBomonInfo: [],
    }
}

const fromJson = (item) => {
    return {
        huanLuyenVienId: item.huanLuyenVienId,
        ten: item.ten,
        diaChi: item.diaChi,
        sdt: item.sdt,
        ghiChu: item.ghiChu,
        stt: item.stt,
        iocId: item.iocId,
        iocEnabled: item.iocEnabled,
        iocDateUpdated: item.iocDateUpdated,
        enabled: item.enabled,
        dateCreated: item.dateCreated,
        userCreated: item.userCreated,
        dateModified: item.dateModified,
        userModified: item.userModified,
        isDeleted: item.isDeleted,
        userDeleted: item.userDeleted,
        dateDeleted: item.dateDeleted,
        tenUserCreated: item.tenUserCreated,
        tenUserModified: item.tenUserModified,
        tenUserDeleted: item.tenUserDeleted,
        thethaoBomonInfo: item.thethaoBomonInfo,
    }
}

const parseModeltoFEModel = (item) => {
    return {
        huanLuyenVienId: item.huanLuyenVienId,
        ten: item.ten,
        diaChi: item.diaChi,
        sdt: item.sdt,
        ghiChu: item.ghiChu,
        stt: item.stt,
        enabled: item.enabled,
        dateCreated: item.dateCreated,
        userCreated: item.userCreated,
        dateModified: item.dateModified,
        userModified: item.userModified,
        isDeleted: item.isDeleted,
        userDeleted: item.userDeleted,
        dateDeleted: item.dateDeleted,
        tenUserCreated: item.tenUserCreated,
        tenUserModified: item.tenUserModified,
        tenUserDeleted: item.tenUserDeleted,
        thethaoBomonInfo: item.thethaoBomonInfo,
    }
}

const errors = () => {
    return {
        huanLuyenVienId: null,
        ten: null,
        diaChi: null,
        sdt: null,
        ghiChu: null,
        stt: null,
        enabled: null,
        listThethaoBomonId: null,
    }
}

const newPagingSearchModel = () => {
    return {
        pageNumber: null,
        pageSize: null,
        sort: null,
        ten: null,
        enabled: null,
    }
}

const newSearchModel = () => {
    return {
        ten: null,
        enabled: null,
    }
}

export const huanLuyenVienTheThaoVHModel = {
    newModel,
    newFEModel,
    parseModeltoFEModel,
    fromJson,
    newPagingSearchModel,
    newSearchModel,
    errors,
}


